import {graphql, useStaticQuery} from "gatsby";

/**
 * Hook to return all available files (assets).
 *
 * @returns {import('../repository/FileRepository.js').File[]} - An array of files.
 */
export const useAllFiles = () => {
  const result = useStaticQuery(graphql`
    query {
        allImages: allFile(filter: {extension: {in: ["png", "jpg", "gif"]}}) {
            nodes {
                id
                name
                publicURL
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                }
            }
        }
        allOtherFiles: allFile(filter: {extension: {nin: ["png", "jpg", "gif"]}}) {
            nodes {
                id
                name
                publicURL
            }
        }
    }
    `);
    
  return { nodes: [].concat(result.allImages.nodes, result.allOtherFiles.nodes) };
}
